// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ENABLE_ADS_MESSAGE = "Spr\u00e1va obsahuje z\u013eavu alebo \u0161peci\u00e1lnu akciu. Povo\u013e reklamy, aby si videla v\u0161etky z\u013eavy a \u0161peci\u00e1lne ponuky, ktor\u00e9 posielame pou\u017e\u00edvate\u013ek\u00e1m Modr\u00e9ho kon\u00edka.";
